import booking from './booking/en'
const en = {
  common: {
    all: 'All',
    download: 'Download',
    private: 'Private',
    sigin: 'SIGN IN',
    recoverPassword: 'Recover password',
    sendMail: 'Send email',
    username: 'Username',
    password: 'Password',
    search: 'Search',
    continue: 'Continue',
    ok: 'OK',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    skip: 'Skip',
    create: 'Create',
    edit: 'Edit',
    clone: 'Clone',
    move: 'Move',
    restore: 'Restore',
    addMenu: 'Create new menu',
    addContent: 'Add to menu',
    addToSubmenu: 'Add to submenu',
    addSubmenu: 'Create submenu',
    addItem: 'Add item',
    delete: 'Delete',
    language: 'Language',
    struct: 'Struct',
    selectImage: 'Select image',
    height: 'Height',
    url: 'URL',
    text: 'Text',
    back: 'Go back',
    send: 'Send',
    of: 'of',
    showMore: 'Show more',
    noData: 'No data',

    open: 'Open',
    openNewTab: 'Open new tab',
    btnText: 'Button text',

    collapse: 'Collapse',
    expand: 'Expand',

    today: 'Today',
    tomorrow: 'Tomorrow',
    m0: 'January',
    m1: 'February',
    m2: 'March',
    m3: 'April',
    m4: 'May',
    m5: 'June',
    m6: 'July',
    m7: 'August',
    m8: 'September',
    m9: 'October',
    m10: 'November',
    m11: 'December',
    s0: 'Monday',
    s1: 'Tuesday',
    s2: 'Wednesday',
    s3: 'Thursday',
    s4: 'Friday',
    s5: 'Saturday',
    s6: 'Sunday',
    s0Small: 'Mo',
    s1Small: 'Tu',
    s2Small: 'We',
    s3Small: 'Th',
    s4Small: 'Fr',
    s5Small: 'Sa',
    s6Small: 'Su',

    addToCalendar: 'Add to calendar',

    error2mb: 'The image cannot exceed 2MB',

    selectMenu: 'Select the menu to move the content',

    addressToSearch: 'Address',

    totemMenuImportant: 'TOTEM - Important menu',
    totemMenuImportantImage: 'TOTEM - Background menu',

    dayOfWeekSmall: {
      0: 'Su',
      1: 'Mo',
      2: 'Tu',
      3: 'We',
      4: 'Th',
      5: 'Fr',
      6: 'Sa'
    },
    dayOfWeek: {
      0: 'Sunday',
      1: 'Monday',
      2: 'Tuesday',
      3: 'Wednesday',
      4: 'Thursday',
      5: 'Friday',
      6: 'Saturday'
    },
    required: 'The fields are required',
    pleaseStandBy: 'Please stanby',
    editMenus: 'Edit menu',

    clear: 'Clear',
    menu: 'Menu',
    content: 'Content',
    messages: {
      confirmDelete: '¿Está seguro de que desea eliminarlo?', // Are you sure you want to delete this item?
      noData: 'No hay datos a mostrar',
      pleaseStandBy: 'Please stanby',
    }
  },
  login: {
    title: 'Login form',
    login: 'login',
    messages: {
      required: 'Username and password are required',
      userNotFound: 'The username or password is incorrect',
      moveContent: 'Move content',
      cloneMenu: 'Clone menu'
    }
  },
  dashboard: {
    title: 'Dashboard',
    changePassword: 'Change password',
    logout: 'Logout',
    webs: 'Web App',
    welcome: 'Welcome',
    lastModification: 'Last modification',
    cloneEnterprise: 'Clone',
    content: 'Content',
    logs: {
      title: 'Logs',
      username: 'User',
      action: 'Action',
      menuname: 'Menu',
      lmd: 'Date',
      actions: {
        deleted: 'Delete',
        update: 'Update',
        sort: 'Sort'
      }
    },
    stats: {
      access: 'Access Web App ',
      accessMenu: 'Accesos menu ',
      month: 'Month',
      day: 'Day',
      menu: 'Menu',
      clicks: 'Clicks'
    }
  },
  changePassword: {
    oldPassword: 'Old password',
    password: 'New password',
    repeatPassword: 'Repeat password',
    messages: {
      oldPasswordRequired: 'The previous password is required',
      passwordRequired: 'Password is required',
      sameAsPassword: 'Passwords must match',
      UserNotFound: 'Username or password does not match',
      success: 'Password updated successfully'
    }
  },
  commonMenus: {
    title: 'Common menus',
    alias: 'Alias',
    messages: {
      update: 'Updated successfully'
    },
    assign: 'Assign'
  },
  users: {
    title: 'Users',
    userTitle: 'User',
    name: 'Name',
    email: 'Email',
    client: 'Client',
    password: 'Password',
    repeatPassword: 'Repeat password',
    isSuperUser: 'Is superuser',
    enterprises: 'Web Apps',
    defaultEnterprise: 'Client by default',
    permissions: {
      title: 'Permissions',
      logs: 'Logs',
      stats: 'Stats',
      moveContent: 'Move content',
      cloneMenu: 'Clone menu',
      cloneEnterprise: 'Clone Web App',
      editDesktopMode: 'Edit desktop mode',
      commonMenus: 'Edit common menus',
      productService: 'Product/Service',
      poll: 'Encuesta'
    },
    dishesMenu: 'Menu dishes administration',
    hideLogoAndCarousel: 'Hide F. logo y carousel',
    hideColors: 'Hide F. colores',
    hideWelcomeModal: 'Hide F.MSJ welcome',
    messages: {
      nameMostCharacters: 'Name must be at most 50 characters long',
      nameRequired: 'E-mail is required',
      emailValid: 'Must be valid e-mail',
      emailRequired: 'E-mail is required',
      passwordMatch: 'Password must match',
    }
  },
  enterprises: {
    title: 'Web Apps',
    enterpriseTitle: 'Client',
    name: 'Client',
    domain: 'Domain',
    allergensIconType: 'Allergens icon type',
    privateBGColor: 'Admin private color',
    btnBackgroundColor: 'Content btn bgcolor',
    btnTextColor: 'Content btn textcolor',
    permissions: 'Permissions',
    dviewLink: 'Activities (Dview link)',
    dviewLinkShows: 'Shows (Dview link)',
    dviewLinkAgenda: 'Agenda (Dview link)',
    dviewLinkParrilla: 'Parrilla (Dview link)',
    dviewLinkCommercial: 'Commercial (Dview link)',
    dviewLinkProperty: 'Property (Dview link)',
    dviewLinkChannelList: 'ChannelList (enlace Dview)',
    showMoscaDFeel: 'Show mosca DFeel',
    allergenFilters: 'Allergen filters',
    showDishesImage: 'Show image',
    showDishesAllergens: 'Show allergen',
    meteo: 'Meteo (zone)',
    linkCommon: 'Enlazar menús compartidos',
    clearStats: 'Reset stats',
    messages: {
      nameMostCharacters: 'Name must be at most 50 characters long',
      nameRequired: 'E-mail is required',
      domainMostCharacters: 'Domain must be at most 50 characters long',
      domainRequired: 'Domain is required'
    },
    backDomain: 'Btn back (domain)',
    authType: 'Auth type',
    expandFirstElement: 'Expand first element',
    expandFirstElementWithoutMainMenu: 'Expand first element without main menu',
    editMenus: 'Settings',
    foodDrinkTextColor: 'Food/Drink textcolor',
  },
  settings: {
    title: 'Settings',
    welcomeModal: {
      title: 'Welcome message',
      isWelcomeModal: 'Welcome message',
      name: 'Name',
      image: 'Image',
      icon: 'Icon',
      message: 'Message',
      colors: 'Colores',
      countDown: 'Count down',
      date: 'Date'
    },
    logoAndCarousel: {
      title: 'Logo and corousel',
      languages: 'Languages',
      logo: 'Logo',
      carousel: 'Carousel',
      defaultLocale: 'Default locale',
      messages: {
        update: 'Updated successfully'
      }
    },
    colors: {
      title: 'Colors',
      primary: 'Primary',
      secundary: 'Secundary',
      content: 'Content',
      backgroundColor: 'Background color',
      fontColor: 'Text color',
      fontSize: 'Font size',
      font: 'Font',
      shadowMenu: 'Shadow menu',
      shadowSubmenu: 'Shadow submenu',
      line: 'Line',
      messages: {
        update: 'Updated successfully'
      },
      textFormat: 'Format'
    },
    formTerms: {
      title: 'Términos y condiciones',
      showCookiePolicy: 'Mostrar políticas de cookies',
      cookiePolicy: 'Política de cookies',
      privacyPolicy: 'Política de privacidad',
      info: 'This site uses cookies. By continuing to browse the site, you are agreeing to our use of cookies.',
      agree: 'Aceptar',
      learnMore: 'Saber más',
    },
    info: {
      recommendations: 'Recommendations',
      logo: {
        title: 'Logo',
        description: 'Minimum size and resolution of the recommended image 800x338px - 72ppp. PNG format with transparent background.'
      },
      carousel: {
        title: 'Carousel',
        description: 'Minimum size and resolution of the recommended image 1280x720px - 72ppp. JPEG format. Maximum three images.'
      },
      language: {
        title: 'Languages',
        description: 'Set the application languages. By default it is in Spanish. Remember that if you select several languages ​​you must place your translation. The application does not translate automatically.'
      }
    }
  },
  menus: {
    name: 'Menus',
    title: 'Settings',
    menuName: 'Menu name',
    submenuName: 'Submenu name',
    submenus: 'Submenus',
    isMenuTemp: 'Temp menu',
    isSubmenuTemp: 'Temp submenú',
    WAAsContent: 'WebApp como contenido',
    domain: 'WebAPP',
    editors: 'Editors',
    info: {
      noExistSubmenu: 'There are no submenus created',
      addMenu: 'You can start adding menus clicking on the next button',
      saveBeforeEdit: 'Save before editing new items',
      collapse: 'To order you must collapse the content',
      iconAndFunction: 'Iconography and general functions:',
      addContent: 'Add to menu',
      addToSubmenu: 'Add to submenu',
      moveContent: 'Move content',
      sortContent: 'Sort content',
      editContent: 'Edit content',
      language: 'Add translations',
      deleteContent: 'Delete content',
      cancel: 'Cancel content',
      menuWithoutContent: 'Menu or submenu without content',
      menuWithContent: 'Menu or submenu with content',
      saveContent: 'Save content',
      submenus: 'Meny con submenus',
      lockContent: 'External content not editable',
      finished: 'Temporary menu out of date',
      cloneContent: 'Clone content',
      hideContent: 'Hide content'
    },
    availability: {
      startDate: 'Start date',
      endDate: 'End date',
      noEndDate: 'No end date'
    },
    messages: {
      update: 'Updated successfully',
      delete: 'Deleted successfully'
    }
  },
  desktopMode: {
    title: 'Desktop view'
  },
  share: {
    title: 'Share',
    downloadSVG: 'Download SVG',
    downloadPNG: 'Download PNG',
    isPrivate: 'Private',
    addAccess: 'Create access',
    alias: 'Alias'
  },
  confirmDelete: {
    title: 'Do you want to remove this content?',
    message: 'This action cannot be reversed.'
  },
  confirmUndo: {
    title: 'Do you want cotinue?',
    message: 'Unsaved modifications will be deleted'
  },
  gallery: {
    maxInfo: 'Max 12 images'
  },
  map: {
    lat: 'Latitude',
    lon:'longitude'
  },
  twitter: {
    account: 'Account'
  },
  facebook: {
    account: 'Account'
  },
  instagram: {
    instagramIframe: 'Iframe'
  },
  activity: {
    type: 'Type',
    show: 'Show',
    messages: {
      noActivities: 'No activities'
    },
    book: 'Book'
  },
  timeline: {
    addEvent: 'Create event',
    title: 'Title',
    description: 'Description',
    hideHeader: 'Hide header'
  },
  contact: {
    addItem: 'Create item',
    description: 'Value',
    hideDivider: 'Hide divider',
    url: 'URL'
  },
  divider: {
    space: 'Space'
  },
  site: {
    title: 'Title',
    subtitle: 'Subtitle',
    address: 'Address',
    phone: 'Phone',
    web: 'Web',
    email: 'E-mail',
    moreInfo: 'More info',
    lat: 'Latitude',
    lon: 'Longitude',
    showMoreInfo: 'Show more info',
    hideMoreInfo: 'Hide info'
  },
  agenda: {
    showMoreInfo: 'Show more info'
  },
  wifi: {
    name: 'Name',
    ssid: 'SSID',
    password: 'Password',
    Authentication: 'Authentication',
    wep: 'WEP',
    wpa: 'WPA'
  },
  food: {
    name: 'Name',
    ingredients: 'Ingredients',
    price: 'Price',
    note: 'Note',
    vegan: 'Vegan',
    vegetarian: 'Vegetarian',
    new: 'New',
    spicy: 'Spicy',
    recommended: 'Recommended',
    allergens: 'Allergens',
    containsAllergens: 'Contains allergens'
  },
  product: {
    name: 'Name',
    description: 'Description',
    price: 'Price',
    promotion: 'Promotion',
  },
  linkDomain: {
    name: 'Name',
    domain: 'Subdomain',
    newTab: 'Open new tab'
  },
  form: {
    formDestinationMail: 'Destination mail',
    formRoomNumber: 'Room number',
    formDateTime: 'Date and time',
    formNumberOfPeople: 'Nº of people',
    name: 'Name',
    formTextBtn: 'Button text',
    roomNum: 'Nº Room',
    email: 'Email',
    phone: 'Phone',
    date: 'Date',
    time: 'Time',
    numOfItems: 'Número de items',
    numOfPeople: 'Number of people',
    lblNumOfItems: 'Text number of items label',
    formLimitNumberOfItem: 'Limit number of items',
    observations: 'Observations',
    messageSend: 'Request sent'
  },
  dishes: {
    title: 'Dishes',
    menu: 'Menu',
    food: 'Dishe',
    ingredients: 'Ingredients',
    price: 'Price',
    vegan: 'Vegan',
    vegetarian: 'Vegetarian',
    allergens: 'Allergens',
    selectYourAllergy: 'Select your allergy',
    allergenFilter: 'ALLERGEN FILTER',
    selectAllergens: 'Select allergens to eliminate products that contain them',
    containsAllergens: 'Contains allergens'
  },
  products: {
    title: 'Product/Service',
  },
  menuType: {
    selectMenuType: 'Select the type of content to add',
    demo: 'Demo',
    activities: 'Activities',
    submenu: 'Submenu',
    simpleText: 'Simple text',
    space: 'Separator',
    image: 'Image',
    iframe: 'Iframe',
    alert: 'Alert',
    cardText: 'Alert',
    gallery: 'Gallery',
    video: 'Video',
    meteo: 'Weather',
    map: 'Map',
    twitter: 'Twitter',
    facebook: 'Facebook',
    pdf: 'PDF',
    timeline: 'Timeline',
    text: 'Text',
    contact: 'Contact',
    divider: 'Line',
    shows: 'Shows',
    site: 'Place',
    agenda: 'Events',
    parrilla: 'Schedule',
    wifi: 'WIFI',
    property: 'Properties',
    commercial: 'Agents',
    queue: 'Turn',
    food: 'Food/Drink',
    linkDomain: 'Webapp link',
    form: 'Form',
    productService: 'Product/Service',
    pdfTranslate: 'PDF T.',
    linkExternal: 'External link',
    channelList: 'Channel list',
    WAAsContent: 'WebApp as content',
    acttiv: 'Acttiv',
    poll: 'Inquiry',
    iconList: 'Icon list',
    instagram: 'Instagram',
    dropdownButton: 'Dropdown button',
    dfiles: 'Dfiles',
    rcovid: 'R-COVID',
    imageTranslate: 'Image T.',
    iberostarFood: 'Iberostar food',
    icons: 'Icons',
    brochure: 'Brochure',
    infoTen: 'InfoTen',
    cmActivities: 'Activities (ContentManager)',
    cMBooking: 'Bookings (ContentManager)',
    menuExtFood: 'Menu ext. Food',
    attendance: 'Registro entrada/salida',
    cMAttendance: 'Registro entrada/salida',
    cmWeeklyMenu: 'Menú semanal',
    formCio: 'Form CIO',
    dviewcontentMessages: 'Mensajes y avisos (dviewcontent)',
    servatur: 'Servatur',
    interactiveMaps: 'Mapa interactivo',
    abamaRequestReservation: 'ABAMA solicitud de reserva',
    effilabel: 'Effilabel',
    effiwaste: 'Effiwaste',
    chekin: 'Chekin',
    qAndA: 'Q&A',
  },
  totem: {
    weatherForecast: 'Weather forecast',
    languageSelector: 'Language selector',
    accessibility: 'Accessibility',
    mobileVersion: 'Mobile version'
  },
  schedule: {
    startTime: 'Start time',
    interval: 'Interval'
  },
  availability: {
    isTemp: 'Temporary',
    periodicity: 'Periodicity',
    allDays: 'All days',
    oneDay: 'One day',
    recurrence: 'Recurrence',
    isAllTimes: 'All day',
    date: 'Date event',
    dateStart: 'Start date',
    dateEnd: 'End date',
    timeStart: 'Start time',
    timeEnd: 'End time',
    noEndDay: 'No end date',
    byWeek: 'By week',
    byMonth: 'By month',
    alternation: 'Alternation'
  },
  customAuth: {
    guestAccess: 'Guest access',
    bookingCode: 'Reservation',
    entranceDate: 'Entrance date',
    room: 'Nº Room',
    surname: 'Surname',
    noray: {
      noCheckin: 'Debe hacer el Check-in',
      exit: 'Salida realizada',
      noBookin: 'Reservation not valid',
      error: 'Unknown error'
    },
    logoutMsg: 'Are you sure you want to logout?'
  },
  acttiv: {
    primaryColor: 'Primary',
    secundaryColor: 'Secundary',
    titleColor: 'Title',
    descriptionColor: 'Description',
    info: 'Activities subject to change',
    reservationCreated: 'Reservation created',
    locator: 'Locator',
    disclaimer: 'Animation program subject to possible changes'
  },
  poll: {
    alias: 'Alias',
    selectType: 'Select type',
    question: 'Question',
    answer: 'Answer',
    multiSelection: 'Multi-selection',
    singleSelection: 'Single selection',
    addAnswer: 'Add answer',
    rating: 'Rating',
    number: 'Number',
    messages: {
      sendDataSuccess: 'Responses submitted successfully'
    }
  },
  reservationList: {
    reservations: 'Reservations',
    myReservations: 'My reservations',
    status: 'Status',
    participant: 'Participant',
    date: 'Date',
    OK: 'OK',
    CANCEL: 'CANCEL'
  },
  dropdownButton: {
    colors: 'Colors'
  },
  rcovid: {
    title: 'Covid form',
    name: 'Name',
    lastName: 'Lastname',
    email: 'Email',
    company: 'Company',
    terms: 'Terms',
    ni: 'DNI',
    phone: 'Phone',
    messageSend: 'Confirmed',
    LMD: 'Date'
  },
  iberostarFood: {
    restaurant: 'Restaurante',
    primaryColor: 'Primary color',
    secondaryColor: 'Secondary color',
  },
  hsconsulting: {
    hotel: 'Hotel',
    installation: 'Installation',
  },
  brochure: {
    description: 'Description',
    note: 'Note',
    facts: 'Data of interest',
    hours: 'Hours',
    price: 'Price',
    services: 'Services',
    contact: 'Contact',
    phone: 'Phone',
    fax: 'Fax',
    email: 'Email',
    web: 'Web',
    location: 'Place',
    zone: 'Zone',
    municipaly: 'Municipality',
    address: 'Address',
    postalCode: 'Postal code',
    lat: 'Latitude',
    lon: 'Logitude',
    pdf: 'PDF',
    openNewTab: 'Open new tab',
    download: 'Download',
    info: 'Information',
  },
  dtouch: {
    email: 'Email',
    room: 'Room',
    access: 'Acceder',
    reservations: 'Bookings',
    pax: 'Pax',
    showBookings: 'Show',
    editBooking: 'Edit',
    cancelBooking: 'Cancel',
    outdatedBooking: 'Outdated',
    request: {
      name: 'Nombre',
      description: 'Descripción',
      request: 'Pedir',
      report: 'Report',
      title: 'Solicitudes',
      item: 'Item',
      fullName: 'Nombre completo',
      email: 'Email',
      room: 'Habitación',
      comment: 'Comentarios',
      status: 'Estado',
      captureImage: 'Capture photo (optional)',
      messages: {
        ok: 'Solicitud registrada correctamente',
        okUpdate: 'Solicitud actualizada correctamente',
        fieldsRequired: 'Faltan campos por informar (*)',
      },
    },
    activity: {
      all: 'All',
      messages: {
        noActivities: 'There are no events for the selected date',
        disclaimer: 'Programa de animación sujeto a posibles cambios',
      },
    },
    dishOrders: {
      title: 'Orders',
      allowOrders: 'Allow orders',
      order: 'Order',
      status: 'State',
      cd: 'Creation date',
      closed: 'Closed',
      closedOpen: 'Close/Open',
      open: 'Open',
      close: 'Close',
      numItems: 'N. items',
      name: 'Name',
      price: 'Price',
      total: 'Total',
      cancelOrder: 'Cancel',
      confirmOrder: 'Confirm',
      payOrder: 'Pay',
      image: 'Image',
      clearOrder: 'Cancel',
      all: 'All',
      note: 'Note',
      finalize: 'Finalize',
      noData: 'Empty',
      labelExtra: 'Texto a mostrar',
      onlyOne: 'Permitir seleccionar solo uno',
      FixCart: 'Fix cart',
      percentage: 'Porcentage',
      allInclusive: 'All inclusive',
      includeExtras: 'Include extras',
      acceptTerms: 'Accept terms',
      extras: {
        title: 'Extras',
        name: 'Name',
        price: 'Price',
      },
      formConfirm: {
        title: 'Último paso',
        fullName: 'Nombre completo',
        room: 'Habitación',
        name: 'Nombre',
        lastName: 'Apellido',
        required: 'Requerido',
        email: 'Email',
        paymentMethods: 'Payment method',
        observations: 'Observations',
        paymentOptions: {
          cash: 'Cash',
          creditCard: 'Credit card',
          room: 'Cargo habitación',
        },
        acceptTerms: {
          title: 'Accept terms.',
          accept: 'Accept ',
          terms: 'terms.'
        },
      },
      points: {
        title: 'Point of order',
        point: 'Point of order',
        name: 'Name',
        order: 'Order',
      },
      messages: {
        orderAdded: 'Order added',
        rememberConfirmOrder: 'Recuerda confirmar el pedido',

        orderConfirmed: 'Order confirmed',
      },
    },

  },
  messages: {
    title: 'Chat',
    typeSomething: 'type something...',
    sessionNotfound: 'Chat not found',
  },
  qAndA: {
    question: 'Question',
    answer: 'Answer',
  },
  noray: {
    fields: {
      arrivalDate: 'Arrival date',
      checkInDate: 'Check-in date',
      email: 'Email',
      hotelVoucher: 'Hotel voucher',
      name: 'Name',
      no: 'No',
      phoneNo: 'Phone',
      roomNo: 'Room',
      voucher: 'Voucher',
    },
    messages: {
      required: 'Required',
    },
  },
  booking,
}

export default en
